import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface SpinnerData {
  title?: string;
  message?: string;
  closable?: boolean; // si el usuario puede cerrarlo manualmente
}

@Component({
  selector: 'app-countdown-popup',
  standalone: true,
  templateUrl: './spinner.html',
})
export class Spinner {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: SpinnerData,
    private dialogRef: MatDialogRef<Spinner>,
  ) {}

  close() {
    this.dialogRef.close(false);
  }
}
